import React, { useState, useEffect } from "react";
import Button from "../Button";
import socket from "../../socket";
import "./styles.css";

const QuizForm = ({ room, onSubmit }) => {
	const [quizConfig, setQuizConfig] = useState({
		numberOfQuestions: 5,
		category: "",
		difficulty: "",
		type: "",
		timer: 10
	});

	const handleSubmit = (e) => {
		e.preventDefault();
		socket.emit("start trivia", { room, quizConfig });
	};

	const handleChange = (e) => {
		setQuizConfig((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value
		}));
	};

	const handleIncrement = (e) => {
		e.preventDefault();
		if (quizConfig.numberOfQuestions < 10) {
			setQuizConfig((prevState) => ({
				...prevState,
				numberOfQuestions: quizConfig.numberOfQuestions + 1
			}));
		}
	};

	const handleDecrement = (e) => {
		e.preventDefault();
		if (quizConfig.numberOfQuestions > 1) {
			setQuizConfig((prevState) => ({
				...prevState,
				numberOfQuestions: quizConfig.numberOfQuestions - 1
			}));
		}
	};

	const handleTimerIncrement = (e) => {
		e.preventDefault();
		if (quizConfig.timer < 20) {
			setQuizConfig((prevState) => ({
				...prevState,
				timer: quizConfig.timer + 1
			}));
		}
	};

	const handleTimerDecrement = (e) => {
		e.preventDefault();
		if (quizConfig.timer > 4) {
			setQuizConfig((prevState) => ({
				...prevState,
				timer: quizConfig.timer - 1
			}));
		}
	};

	useEffect(() => {
		socket.emit("change quiz configuration", { room, quizConfig });
	}, [room, quizConfig]);

	useEffect(() => {
		socket.on("users", () => {
			socket.emit("change quiz configuration", { room, quizConfig });
		});
	}, [room, quizConfig]);

	return (
		<>
			<div>
				<p>{quizConfig.numberOfQuestions}</p>
				<Button
					onClick={(e) => {
						handleDecrement(e);
					}}
					text={
						<>
							Subtract<span></span>
							<span class="cybrBtnGlitch">Subtract</span>
						</>
					}
				/>
				<Button
					onClick={(e) => {
						handleIncrement(e);
					}}
					text={
						<>
							Add<span></span>
							<span class="cybrBtnGlitch">Add</span>
						</>
					}
				/>
				<p>{quizConfig.timer}s</p>
				<Button
					onClick={(e) => {
						handleTimerDecrement(e);
					}}
					text={
						<>
							Subtract<span></span>
							<span class="cybrBtnGlitch">Subtract</span>
						</>
					}
				/>
				<Button
					onClick={(e) => {
						handleTimerIncrement(e);
					}}
					text={
						<>
							Add<span></span>
							<span class="cybrBtnGlitch">Add</span>
						</>
					}
				/>
				<form id="quizform" onSubmit={handleSubmit}>
					<select
						name="category"
						value={quizConfig.category}
						onChange={handleChange}
					>
						<option value="">Any Category</option>
						<option value="9">General Knowledge</option>
						<option value="10">Entertainment: Books</option>
						<option value="11">Entertainment: Film</option>
						<option value="12">Entertainment: Music</option>
						<option value="13">Entertainment: Musicals & Theatres</option>
						<option value="14">Entertainment: Television</option>
						<option value="15">Entertainment: Video Games</option>
						<option value="16">Entertainment: Board Games</option>
						<option value="17">Science & Nature </option>
						<option value="18">Science: Computers</option>
						<option value="19">Science: Mathematics</option>
						<option value="20">Mythology</option>
						<option value="21">Sports</option>
						<option value="22">Geography</option>
						<option value="23">History</option>
						<option value="24">Politics</option>
						<option value="25">Art</option>
						<option value="26">Celebrities</option>
						<option value="27">Animals</option>
						<option value="28">Vehicles</option>
						<option value="29">Entertainment: Comics</option>
						<option value="30">Science: Gadgets</option>
						<option value="31">Entertainment: Japanese Anime & Manga</option>
						<option value="32">Cartoon & Animations</option>
					</select>
					<select
						name="difficulty"
						value={quizConfig.difficulty}
						onChange={handleChange}
					>
						<option value="">Any Difficulty</option>
						<option value="easy">Easy</option>
						<option value="medium">Medium</option>
						<option value="hard">Hard</option>
					</select>
					<select name="type" value={quizConfig.type} onChange={handleChange}>
						<option value="">Any Type</option>
						<option value="multiple">Multiple Choice</option>
						<option value="boolean">True / False</option>
					</select>
				</form>
				<Button
					form="quizform"
					type="submit"
					text={
						<>
							Start<span aria-hidden></span>
							<span aria-hidden class="cybrBtnGlitch">
								Start
							</span>
						</>
					}
				/>
			</div>
		</>
	);
};

export default QuizForm;
